import { render, staticRenderFns } from "./SiteLink.vue?vue&type=template&id=0a993d45"
import script from "./SiteLink.vue?vue&type=script&lang=js"
export * from "./SiteLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports